import { Injectable } from '@angular/core';
import { CompleteData } from 'cbc-shared-lib';
import { BehaviorSubject, Observable } from 'rxjs';

const INITIALIZE_DATA: CompleteData = {
  title: '',
  message: '',
  next: '',
  koumokuList: [],
}

/**
 * 共通完了画面サービス
 * @export
 * @class CompleteDataService
 */
@Injectable({
  providedIn: 'root'
})
export class CompleteDataService {
  /**
   * 完了画面表示データ
   * @type {CompleteData}
   * @memberof CompleteDataService
   */
  _completeData$: BehaviorSubject<CompleteData> = new BehaviorSubject<CompleteData>({});

  /**
   * 完了画面データのobservable提供
   *
   * @readonly
   * @memberof CompleteDataService
   */
  get valueChange(): Observable<CompleteData> {
    return this._completeData$.asObservable();
  }

  /**
   * 完了画面データ設定
   *
   * @type {void}
   * @memberof CompleteDataService
   */
  set completeData(data: CompleteData) {
    this._completeData$.next(data);
  }

  /**
   * コンストラクタ
   * @memberof CompleteDataService
   */
  constructor() {
    this.initializeData();
  }

  /**
   * オブジェクト破棄処理
   * @memberof CompleteDataService
   */
  ngOnDestroy() {
  }

  /**
   * 画面表示データ初期化
   * 完了画面のngOnDestroy()で呼び出す
   * @memberof CompleteDataService
   */
  public initializeData() {
    this._completeData$.next(INITIALIZE_DATA);
  }

}
